<template>
    <div>
        <md-button title="Add new charge" class="md-success" @click="showCreateNewLineDialog">
            Add new {{ title }}
        </md-button>

        <md-dialog class="create-mobile-container" :md-active.sync="showDialog">
            <md-dialog-title>Add New {{ title }}</md-dialog-title>
            <md-dialog-content>
                <form @submit.prevent="createLine">
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label>Description</label>
                                <md-input v-model="lineForm.description" required maxlength="100"></md-input>
                            </md-field>
                        </div>

                        <div class=" md-layout-item md-size-100date-inputs-container">
                            <div class="date-input-wrapper">
                                <md-field class="date-field">
                                    <md-datepicker v-model="lineForm.tripDate" required md-immediately></md-datepicker>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label>Amount</label>
                                <md-input
                                    v-model.number="lineForm.unitPriceExTax"
                                    required
                                    maxlength="10"
                                    type="number"
                                ></md-input>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label>Account Code</label>
                                <md-input v-model="lineForm.accountCode" maxlength="15"></md-input>
                            </md-field>
                        </div>
                    </div>
                </form>
            </md-dialog-content>
            <md-dialog-actions class="actions-custom">
                <md-button class="md-default" @click="showDialog = false">Cancel</md-button>
                <md-button class="md-primary" @click="createLine" :disabled="!isFormValid">Create</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import moment from 'moment';
import { GeneralMixin } from '@/mixins';
import { handleRequests, showErrorMessage } from '@/helpers';

export default {
    name: 'AddNewLineToDraftInvoice',
    props: {
        invoiceId: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        stopId: {
            type: Number,
            default: null
        },
        shipmentId: {
            type: Number,
            default: null
        },
        tripId: {
            type: Number,
            default: null
        },
        runId: {
            type: Number,
            default: null
        }
    },
    mixins: [GeneralMixin],
    data() {
        return {
            showDialog: false,
            lineForm: {
                tripDate: moment().format('YYYY-MM-DD'),
                description: null,
                unitPriceExTax: 0,
                accountCode: null
            }
        };
    },
    computed: {
        isFormValid() {
            return (
                this.lineForm.tripDate !== null &&
                (this.lineForm.description !== null && this.lineForm.description !== '') &&
                this.lineForm.unitPriceExTax !== null
            );
        }
    },
    methods: {
        showCreateNewLineDialog() {
            this.showDialog = true;
        },
        async createLine() {
            if (!this.isFormValid) {
                this.$notify({
                    message: 'Please fill in all required fields',
                    type: 'warning'
                });
                return;
            }

            try {
                const payload = {
                    method: 'post',
                    data: {
                        tripDate: this.lineForm.tripDate,
                        description: this.lineForm.description,
                        unitPriceExTax: this.lineForm.unitPriceExTax,
                        accountCode: this.lineForm.accountCode,
                        invoiceId: this.invoiceId,
                        stopId: this.stopId,
                        shipmentId: this.shipmentId,
                        tripId: this.tripId,
                        runId: this.runId
                    }
                };

                this.$_handleLoaderState(true, '...CREATING');
                let api = '';

                if (this.title === 'Cost') {
                    api = `/api/team-member-invoices/line`;
                } else if (this.title === 'Charge') {
                    api = `/api/customer-invoices/line`;
                }

                const response = await handleRequests(api, payload);

                if (response.data) 
                    this.$emit('lineCreated', response.data);

                this.$notify({
                    message: 'Created successfully',
                    type: 'success'
                });
            } catch (error) {
                const message = 'There was an error creating a new charge';
                showErrorMessage(this, message, error);
            } finally {
                this.resetForm();
                this.showDialog = false;
                this.$_handleLoaderState(false);
            }
        },
        resetForm() {
            this.lineForm = {
                tripDate: moment().format('YYYY-MM-DD'),
                description: null,
                unitPriceExTax: 0,
                accountCode: null
            };
        }
    }
};
</script>
<style lang="scss" scoped>
.actions-custom {
    padding: 0px 24px 24px;
}

@media screen and (max-width: 768px) {
    .create-mobile-container {
        max-height: 80%;
    }
}

.date-field {
    margin: 0 !important;
    padding: 0 !important;
    min-height: auto !important;
}

.date-input-wrapper {
    flex: 1 !important;
    min-width: 0 !important;
}

.date-inputs-container {
    margin-top: 0;
    margin-bottom: 0px;
    font-weight: 500;
}

::v-deep .md-count {
    position: static !important;
}
</style>
